import {
    Icon20Chain,
    Icon20CloudOutline,
    Icon20DeleteOutline,
    Icon20DiscountOutline,
    Icon20GovernmentOutline,
    Icon20LikeOutline,
    Icon20LogoVkOutline,
    Icon20MailOutline,
    Icon20PictureOutline,
    Icon20PictureStackOutline,
    Icon20RecentOutline,
    Icon20ShareExternalOutline,
    Icon20UsersOutline,
} from '@vkontakte/icons';
import React from 'react';
import { EStorageType } from 'reactApp/modules/storage/storage.types';
import { DiscountPromocodesList } from 'reactApp/sections/SubscriptionsPage/ui/DiscountPromocodesList/DiscountPromocodesList';
import { TreeNodeData } from 'reactApp/ui/TreeComponent/TreeNode.types';
import { Icon20DeleteClockOutline, Icon20FolderOutline } from 'reactApp/ui/VKUIIcons';

export enum ETreeRootIds {
    home = '/',
    gallery = '/gallery',
    favorites = '/favorites',
    feed = '/feed',
    domain = '/domain',
    incoming = '/incoming',
    sharedIncoming = '/shared/incoming',
    sharedLinks = '/shared/links',
    sharedAutodelete = '/shared/autodelete',
    attaches = '/attaches',
    recommend = '/recommend',
    trashbin = '/trashbin',
    start = '/start',
    promocodes = '/promocodes',
    documents = '/documents',
    albums = '/albums',
}

export const treeItemsFlatten = {
    [ETreeRootIds.start]: {
        id: ETreeRootIds.start,
        gaId: 'start',
        title: 'Быстрый доступ',
        storage: EStorageType.start,
        folderCounter: 2,
        icon: <Icon20CloudOutline />,
        href: `/start`,
    },
    [ETreeRootIds.incoming]: {
        id: ETreeRootIds.incoming,
        title: 'Совместные',
        gaId: 'sovm',
        storage: EStorageType.sharedLinks,
        folderCounter: 2,
        icon: <Icon20Chain />,
    },
    [ETreeRootIds.sharedLinks]: {
        id: ETreeRootIds.sharedLinks,
        title: 'Вы поделились',
        storage: EStorageType.sharedLinks,
        icon: <Icon20ShareExternalOutline />,
        folderCounter: 0,
        href: `/shared/links`,
    },
    [ETreeRootIds.sharedIncoming]: {
        id: ETreeRootIds.sharedIncoming,
        title: 'С вами поделились',
        storage: EStorageType.sharedIncoming,
        icon: <Icon20UsersOutline />,
        folderCounter: 0,
        href: `/shared/incoming`,
    },
    [ETreeRootIds.feed]: {
        id: ETreeRootIds.feed,
        gaId: 'feed',
        title: 'Последние',
        storage: EStorageType.feed,
        icon: <Icon20RecentOutline />,
        href: `/feed`,
    },
    [ETreeRootIds.favorites]: {
        id: ETreeRootIds.favorites,
        gaId: 'favorites',
        title: 'Избранные',
        storage: EStorageType.favorites,
        icon: <Icon20LikeOutline />,
        href: `/favorites`,
    },
    [ETreeRootIds.gallery]: {
        id: ETreeRootIds.gallery,
        title: 'Галерея',
        gaId: 'camera uploads',
        storage: EStorageType.gallery,
        icon: <Icon20PictureOutline />,
        isMobile: true,
        href: `/gallery`,
    },
    [ETreeRootIds.sharedAutodelete]: {
        id: ETreeRootIds.sharedAutodelete,
        title: 'Автоудаляемые',
        gaId: 'autodelete',
        storage: EStorageType.sharedAutodelete,
        icon: <Icon20DeleteClockOutline />,
        href: `/shared/autodelete`,
    },
    [ETreeRootIds.documents]: {
        id: ETreeRootIds.documents,
        title: 'Личные документы',
        gaId: 'documents',
        storage: EStorageType.documents,
        icon: <Icon20GovernmentOutline />,
        href: `/documents`,
    },
    [ETreeRootIds.home]: {
        id: ETreeRootIds.home,
        gaId: 'home',
        title: 'Все файлы',
        storage: EStorageType.home,
        folderCounter: 2,
        icon: <Icon20FolderOutline />,
        href: `/home`,
        isMobile: true,
    },
    [ETreeRootIds.domain]: {
        id: ETreeRootIds.domain,
        title: 'Общие папки',
        storage: EStorageType.home,
        folderCounter: 2,
        icon: <Icon20FolderOutline />,
    },
    [ETreeRootIds.attaches]: {
        id: ETreeRootIds.attaches,
        gaId: 'attaches',
        title: 'Из почты',
        storage: EStorageType.attaches,
        folderCounter: 2,
        icon: <Icon20MailOutline />,
        href: `/attaches`,
    },
    [ETreeRootIds.recommend]: {
        id: ETreeRootIds.recommend,
        gaId: 'recomm',
        title: 'VK рекомендует',
        storage: EStorageType.recommend,
        folderCounter: 0,
        icon: <Icon20LogoVkOutline />,
        href: `/recommend`,
    },
    [ETreeRootIds.trashbin]: {
        id: ETreeRootIds.trashbin,
        gaId: 'trash',
        title: 'Корзина',
        storage: EStorageType.trashbin,
        folderCounter: 0,
        itemsCounter: 0,
        icon: <Icon20DeleteOutline />,
        isMobile: true,
        href: `/trashbin`,
    },
    [ETreeRootIds.promocodes]: {
        id: ETreeRootIds.promocodes,
        title: 'Промокоды',
        gaId: 'promocodes',
        storage: EStorageType.promocodes,
        icon: <Icon20DiscountOutline />,
        folderCounter: 2,
        component: <DiscountPromocodesList gaSuffix="tree" />,
    },
    [ETreeRootIds.albums]: {
        id: ETreeRootIds.albums,
        title: 'Альбомы',
        gaId: 'albums',
        storage: EStorageType.albums,
        icon: <Icon20PictureStackOutline />,
        href: '/albums',
    },
};

export const treeRootConfig: TreeNodeData[] = [
    {
        ...treeItemsFlatten[ETreeRootIds.start],
        children: [
            {
                ...treeItemsFlatten[ETreeRootIds.incoming],
                children: [treeItemsFlatten[ETreeRootIds.sharedLinks], treeItemsFlatten[ETreeRootIds.sharedIncoming]],
            },
            treeItemsFlatten[ETreeRootIds.feed],
            treeItemsFlatten[ETreeRootIds.favorites],
            treeItemsFlatten[ETreeRootIds.gallery],
            treeItemsFlatten[ETreeRootIds.albums],
            treeItemsFlatten[ETreeRootIds.sharedAutodelete],
            treeItemsFlatten[ETreeRootIds.documents],
        ],
    },
    treeItemsFlatten[ETreeRootIds.home],
    treeItemsFlatten[ETreeRootIds.domain],
    treeItemsFlatten[ETreeRootIds.attaches],
    treeItemsFlatten[ETreeRootIds.recommend],
    treeItemsFlatten[ETreeRootIds.trashbin],
    treeItemsFlatten[ETreeRootIds.promocodes],
];
